import React, { useEffect, useState, useRef } from 'react';
import { fetchClipsFeed, fetchRandomClip } from '../../services/api';

const ClipsVideoRandom = ({ language = null }) => {
  const [clips, setClips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentClip, setCurrentClip] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [nextCursor, setNextCursor] = useState(null);

  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);

  const [seed] = useState(() => Math.random().toString(36).slice(2));


  const videoRef = useRef(null);

  const galleryRef = useRef(null);


  const loadClips = async (cursor = null) => {
    setLoading(true);
    try {
      const data = await fetchClipsFeed({ nextUrl: cursor, language, seed });
      console.log('Clips fetched:', data.results);

      if (cursor) {
        setClips((prev) => [...prev, ...data.results]);
      } else {
        setClips(data.results || []);
        if (data.results && data.results.length > 0) {
          setCurrentClip(data.results[0]);
          setCurrentIndex(0);
        }
      }

      setNextCursor(data.next || null);
    } catch (err) {
      console.error('Error fetching clips:', err);
      setError('Failed to load clips.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setClips([]);
    setNextCursor(null);
    setCurrentClip(null);
    setCurrentIndex(0);
    setIsFullScreen(false);

    loadClips();
  }, [language]);

  useEffect(() => {
    document.body.style.overflow = isFullScreen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isFullScreen]);

  useEffect(() => {
    if (clips[currentIndex]) {
      setCurrentClip(clips[currentIndex]);
    }
  }, [clips, currentIndex]);

  useEffect(() => {
    const gallery = galleryRef.current;
    if (gallery) {
      const { scrollWidth, clientWidth } = gallery;
      setShowRightArrow(scrollWidth > clientWidth); // show right arrow if scrollable
      setShowLeftArrow(false); // always start hidden
    }
  }, [clips]);


  const openFullScreen = (clip, index) => {
    setCurrentClip(clip);
    setCurrentIndex(index);
    setIsFullScreen(true);
  };

  const closeFullScreen = () => {
    setIsFullScreen(false);
    if (videoRef.current?.pause) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  const navigateClip = async (direction) => {
    if (!clips.length) return;

    const targetIndex = currentIndex + direction;

    // Forward navigation past loaded clips
    if (targetIndex >= clips.length) {
      if (nextCursor) {
        await loadClips(nextCursor);
        setCurrentIndex(targetIndex);
      }
      return;
    }

    // Backward navigation
    if (targetIndex < 0) {
      setCurrentIndex(clips.length - 1);
      return;
    }

    setCurrentIndex(targetIndex);
  };


  const renderClipContent = (content) => ({ __html: content });

  if (loading && !clips.length) return <div>Loading clips...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;
  if (!clips.length) return <div>No clips available yet.</div>;

  const handleScroll = () => {
    const gallery = galleryRef.current;
    if (!gallery) return;

    const { scrollLeft, scrollWidth, clientWidth } = gallery;

    // Arrow visibility
    setShowLeftArrow(scrollLeft > 10);
    setShowRightArrow(scrollLeft + clientWidth < scrollWidth - 10);

    // Infinite loading (unchanged behavior)
    if (
      nextCursor &&
      !loading &&
      scrollLeft + clientWidth >= scrollWidth - 50
    ) {
      loadClips(nextCursor);
    }
  };


  const scrollGallery = (direction) => {
    const gallery = galleryRef.current;
    if (!gallery) return;

    gallery.scrollBy({
      left: direction * gallery.clientWidth * 0.8,
      behavior: 'smooth',
    });
  };

  const openRandomClip = async () => {
  try {
    const clip = await fetchRandomClip();  // fetch truly random clip from backend
    openFullScreen(clip, 0);               // index doesn't matter here
  } catch (err) {
    console.error('Failed to fetch random clip', err);
  }
};





  return (
    <div>
      {!isFullScreen ? (
        <div style={{ position: 'relative' }}>
          {showLeftArrow && (
            <button
              onClick={() => scrollGallery(-1)}
              style={{
                position: 'absolute',
                left: 10,                // mirror the right button
                top: '50%',
                transform: 'translateY(-50%)',
                height: '50px',
                width: '50px',
                borderRadius: '50%',
                background: 'white',
                border: 'none',
                fontSize: '3rem',
                cursor: 'pointer',
                zIndex: 10,
                color: 'black',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
              }}
            >
              ‹
            </button>
          )}
          {showRightArrow && (
            <button
              onClick={() => scrollGallery(1)}
              style={{
                position: 'absolute',
                right: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                height: '50px',
                width: '50px',
                borderRadius: '50%',
                background: 'white',
                border: 'none',
                fontSize: '3rem',
                cursor: 'pointer',
                zIndex: 10,
                color: 'black',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
              }}
            >
              ›
            </button>
          )}
          <div
            className="video-gallery"
            style={{ display: 'flex', overflowX: 'auto' }}
            ref={galleryRef}
            onScroll={handleScroll}
          >

            {/* "Click to open player" card */}
            <div
              className="video-thumbnail"
              style={{
                margin: '0 10px',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: '#4B5563',
                color: 'white',
                fontSize: '25px',
                fontWeight: 'bold',
                borderRadius: '15px',
                height: '450px',

                textAlign: 'center',
              }}
              onClick={openRandomClip}
            >
              Tap to watch full screen

            </div>

            {clips.map((clip, index) => (
              <div
                key={clip.id}
                className="video-thumbnail"
                style={{ margin: '0 10px', cursor: 'pointer' }}
                onClick={() => openFullScreen(clip, index)}
              >
                <div dangerouslySetInnerHTML={renderClipContent(clip.description)} />
              </div>
            ))}
            {/* Loader at the end */}
            {loading && clips.length > 0 && (
              <div
                className="video-thumbnail skeleton-loader"
                style={{
                  margin: '0 10px',
                  borderRadius: '15px',
                  height: '450px',          // match video thumbnail height
                  width: '250px',           // approximate thumbnail width
                  background: 'linear-gradient(90deg, #e0e0e0 25%, #c0c0c0 50%, #e0e0e0 75%)',
                  backgroundSize: '200% 100%',
                  animation: 'skeleton-loading 1.5s infinite',
                }}
              />
            )}

          </div>
        </div>
      ) : (
        <div
          className="full-screen-video"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'black',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <button
            onClick={closeFullScreen}
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              fontSize: '2.5rem',
              color: 'white',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            &times;
          </button>

          <button
            onClick={() => navigateClip(-1)}
            style={{
              position: 'absolute',
              top: '50%',
              left: '20px',
              transform: 'translateY(-50%)',
              fontSize: '4rem',
              color: 'white',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            ‹
          </button>

          {/* Embedded clip */}
          <div dangerouslySetInnerHTML={renderClipContent(currentClip.description)} />

          <button
            onClick={() => navigateClip(1)}
            style={{
              position: 'absolute',
              top: '50%',
              right: '20px',
              transform: 'translateY(-50%)',
              fontSize: '4rem',
              color: 'white',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            ›
          </button>
        </div>
      )}
    </div>
  );
};

export default ClipsVideoRandom;
